import { createFileRoute } from "@tanstack/react-router";

import { VerifyPhone } from "@/features/my/verify-phone";

export const Route = createFileRoute("/(member)/(protected)/my/verify-phone")({
  component: VerifyPhone,
});
